import { routes } from '@tymely/config';
import { IUserRole } from '@tymely/atoms';

type SidebarMenuItem = {
    label: string;
    route: string;
    allowedRoles: IUserRole[];
};

export const sidebarMenuItems: SidebarMenuItem[] = [
    { label: 'Policy Editor', route: routes.graphPolicyEditor, allowedRoles: ['admin', 'external-analyst'] },
    { label: 'Arguments Metadata', route: routes.argumentMetadataView, allowedRoles: ['admin'] },
    { label: 'Actions Metadata', route: routes.actionMetadataView, allowedRoles: ['admin'] },
    { label: 'Organization Editor', route: routes.organizationEditor, allowedRoles: ['admin'] },
    { label: 'Template Editor', route: routes.templateEditor, allowedRoles: ['admin'] },
    { label: 'Prompt Editor', route: routes.promptEditor, allowedRoles: ['admin'] },
    { label: 'Ticket Exchange', route: routes.ticketExchange, allowedRoles: ['admin'] },
    { label: 'Chat Simulation', route: routes.chatSimulation, allowedRoles: ['admin'] },
    { label: 'Live Resolutions', route: routes.liveResolutions, allowedRoles: ['admin'] },
    { label: 'Audit Log', route: routes.databaseHistory, allowedRoles: ['admin'] },
    { label: 'QA Management', route: routes.qaManagement, allowedRoles: ['admin'] },
];
